var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PaysTable',{attrs:{"pays":_vm.pays},on:{"refreshPays":_vm.getFilteredPays}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }